import React, { Component, Fragment } from 'react';
import { View, Image } from 'react-native';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withFormik, Form, Field, ErrorMessage } from 'formik';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import Moment from 'moment';

import { Creators as toastActions } from '../../store/ducks/toast';
import { Creators as produtosActions } from '../../store/ducks/produtos';
import { Creators as produtoSelecionadoActions } from '../../store/ducks/produto-selecionado';
import { Creators as departamentoSelecionadoActions } from '../../store/ducks/departamento-selecionado';

import { produtoSchema } from '../../constants/schemas';
import { PLANOS } from '../../constants/planos';

import Modal from '../../react-component/modal';

import { inputComponentStyle, selectComponentStyle } from './styles';
import styles from './styles';
import { getDepartamentos, saveProduto } from './api';
import Colors from '../../config/Colors';

import { urlCdn } from '../../config/Env';
import { isValidImage } from '../../config/ValidateImage';

import { FotosComponent } from './components/fotosComponent';

import { ProdutoProvider } from './useProduto';

const noImage = require('../../assets/img/no-image.png');
const imageApi = `${urlCdn}/images/{idImagem}`;

const moneyMask = createNumberMask({
    prefix: 'R$ ',
    allowDecimal: true,
    decimalSymbol: ',',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.'
});

const minDate = new Date();
const dateMask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

const brDtFormat = 'DD/MM/YYYY',
    usDtFormat = 'YYYY-MM-DD';

class ProdutoWrapper extends Component {
    state = {
        isLoading: false,
        departamentos: [],
        imageUrl: noImage,
        imageUrlDef: noImage,
        imageExist: false,
        startDate: minDate,
        produtoAtual: {}
    };

    componentDidMount = async () => {
        const { produto, setValues } = this.props,
            produtoAtualObj = {};

        if (produto) {
            const {
                dtInicioPromocao = null,
                dtFimPromocao = null,
                vlPrecoPromocao = 0,
                vlPreco = 0
            } = produto;

            let newVlPreco = vlPreco;

            if (typeof vlPreco === 'string') {
                newVlPreco = vlPreco
                    .replace('.', '')
                    .replace(',', '.')
                    .replace(/[^\d.]/g, '');
            }

            newVlPreco = Number(newVlPreco).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });

            produto.vlPreco = newVlPreco;

            let newVlPrecoPromocao = vlPrecoPromocao;

            if (typeof vlPrecoPromocao === 'string') {
                newVlPrecoPromocao = vlPrecoPromocao
                    .replace('.', '')
                    .replace(',', '.')
                    .replace(/[^\d.]/g, '');
            }

            newVlPrecoPromocao = Number(newVlPrecoPromocao).toLocaleString(
                'pt-BR',
                {
                    style: 'currency',
                    currency: 'BRL'
                }
            );

            produto.vlPrecoPromocao = newVlPrecoPromocao;

            setValues({ ...produto });

            if (vlPrecoPromocao && dtInicioPromocao && dtFimPromocao) {
                const newDates = {
                    dtInicioPromocao: Moment(
                        dtInicioPromocao,
                        usDtFormat
                    ).format(brDtFormat),
                    dtFimPromocao: Moment(dtFimPromocao, usDtFormat).format(
                        brDtFormat
                    )
                };

                setValues({ ...produto, ...newDates });
            }

            this.setState({ ...this.state });

            const { idImagem } = produto;
            const imageUrl = imageApi.replace(/{idImagem}/gi, idImagem),
                imageValid = await isValidImage(imageUrl);

            if (imageValid) {
                this.setState({ ...this.state, imageUrl, imageExist: true });
            }

            Object.keys(produto).forEach(function (key) {
                if (key === 'idDepartamento') {
                    produtoAtualObj[key] = Number(produto[key]);
                } else if (key === 'image') {
                    if (produto[key] === noImage && produto.dsProduto) {
                        produtoAtualObj[key] = 'default';
                    } else if (produto[key] === noImage && !produto.dsProduto) {
                        produtoAtualObj[key] = undefined;
                    } else {
                        produtoAtualObj[key] = produto[key];
                    }
                } else if (
                    key === 'dtInicioPromocao' ||
                    key === 'dtFimPromocao'
                ) {
                    produtoAtualObj[key] = produto[key]
                        ? Moment(produto[key], usDtFormat).format(brDtFormat)
                        : null;
                } else if (
                    key === 'idImagem' &&
                    produto[key] &&
                    produto.nrEan
                ) {
                    let strNr = String(produto.nrEan),
                        tam = strNr.length,
                        strId = produto[key],
                        res = strId.substr(0, tam);
                    res !== strNr
                        ? (produtoAtualObj[key] = produto[key])
                        : (produtoAtualObj[key] = 'default') &&
                          (produtoAtualObj.image = 'default');
                } else {
                    produtoAtualObj[key] = produto[key];
                }
            });

            this.setState({
                ...this.state,
                produtoAtual: produtoAtualObj
            });
        }

        const departamentos = await getDepartamentos();

        this.setState({ ...this.state, departamentos });
    };

    componentWillReceiveProps(nextProps) {
        const { imageUrlDef } = this.state;

        this.setState({ isLoading: true }, () => {
            let reader = new FileReader();

            if (nextProps.values.image === noImage) {
                reader.onloadend = () => {
                    this.setState({
                        loading: false,
                        imageUrl: imageUrlDef,
                        imageExist: false
                    });
                };
                reader.readAsDataURL(this.convertBase64ToFile(noImage));
            } else if (nextProps.values.image) {
                reader.onloadend = () => {
                    this.setState({
                        loading: false,
                        imageUrl: reader.result,
                        imageExist: true
                    });
                };
                reader.readAsDataURL(nextProps.values.image);
            }
        });
    }

    convertBase64ToFile = (image) => {
        const i = image.indexOf('base64,');
        const buffer = Buffer.from(image.slice(i + 7), 'base64');

        var parts = [
            new Blob(buffer, { type: 'image/png' }),
            new Uint16Array([i])
        ];
        var file = new File(parts, 'no-image', {
            lastModified: new Date(0),
            type: 'image/png'
        });

        return file;
    };

    verifyImageIsValid = async (imageUrl) => {
        const { imageUrlDef } = this.state;
        var imageIsValid = await isValidImage(imageUrl);

        if (imageUrl === imageUrlDef) {
            imageIsValid = true;
        }

        return imageIsValid;
    };

    renderImage = () => {
        const { imageUrl, imageExist } = this.state;
        if (imageExist) {
            return (
                <Image
                    style={styles.image}
                    resizeMode={'contain'}
                    source={imageUrl}
                />
            );
        }
    };

    renderImageDef = () => {
        const { imageUrl, imageExist } = this.state;
        if (!imageExist) {
            return (
                <Image
                    style={styles.image}
                    resizeMode={'center'}
                    source={imageUrl}
                />
            );
        }
    };

    closeModal = () => {
        const { values } = this.props,
            { produtoAtual } = this.state,
            { idProduto } = values,
            productToCompare = {};

        Object.keys(values).forEach(function (key) {
            if (key === 'idDepartamento') {
                productToCompare[key] = Number(values[key]);
            } else if (key === 'idImagem' && values[key] && values.nrEan) {
                let strNr = String(values.nrEan),
                    tam = strNr.length,
                    strId = values[key],
                    res = strId.substr(0, tam),
                    result;

                res !== strNr ? (result = true) : (result = false);
                result
                    ? (productToCompare[key] = values[key])
                    : (productToCompare[key] = 'default') &&
                      (productToCompare.image = 'default');
            } else if (key === 'image') {
                if (values[key] === noImage && values.dsProduto) {
                    productToCompare[key] = 'default';
                } else if (values[key] === noImage && !values.dsProduto) {
                    productToCompare[key] = undefined;
                } else {
                    productToCompare[key] = values[key];
                }
            } else {
                productToCompare[key] = values[key];
            }
        });

        Object.keys(values).forEach(function (key) {
            if (values[key] === '') {
                values[key] = undefined;
            }
        });

        if (
            produtoAtual.hasOwnProperty('vlPreco' || 'vlPrecoPromocao') &&
            JSON.stringify(productToCompare) !== JSON.stringify(produtoAtual) &&
            JSON.stringify(values) !== JSON.stringify(produtoAtual)
        ) {
            let confirm = window.confirm(
                `Cancelar ${idProduto ? 'edição' : 'cadastro'} de produto?`
            );
            if (confirm) {
                this.props.onClose();
            } else {
                confirm = null;
            }
        } else {
            this.props.onClose();
        }
    };

    handleBlur = (e) => {
        const { target } = e,
            { value, name } = target;

        let newValue = value
            .toString()
            .replace('.', '')
            .replace(',', '.')
            .replace(/[^\d.]/g, '');

        newValue = Number(newValue).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });

        this.props.setFieldValue(name, newValue);
    };

    checkHasVlPrecoPromocao = () => {
        const { values = {} } = this.props,
            { vlPrecoPromocao = 0 } = values;

        if (!vlPrecoPromocao) {
            return true;
        }

        let value = vlPrecoPromocao
                .toString()
                .replace('.', '')
                .replace(',', '.')
                .replace(/[^\d.]/g, ''),
            hasValue = Number(value) === 0;

        return hasValue;
    };

    render() {
        const { departamentos = [] } = this.state,
            {
                user,
                values,
                touched,
                errors,
                handleChange,
                setFieldTouched,
                isSubmitting,
                produto = {}
            } = this.props,
            { plano = {} } = user,
            { idPlano } = plano;

        let disableEdit = false;

        if (idPlano !== PLANOS.STANDARD) {
            disableEdit = true;
        }

        const arrImages = produto.lsProdutoImagem || [];

        return (
            <Fragment>
                <Modal
                    width="50%"
                    title="Cadastro de Produto"
                    isOpen={true}
                    onClose={this.closeModal}
                    onSave={this.validateForm}
                    enabledClose={true}
                    cancelText="Cancelar"
                    saveText="Salvar"
                    isSaveButtonLoading={isSubmitting}
                >
                    <div>
                        <Form>
                            <div style={styles.container}>
                                <View
                                    style={[
                                        styles.formContainer,
                                        styles.firstSon
                                    ]}
                                >
                                    <View style={styles.inputContainer}>
                                        <label style={styles.label}>
                                            Descrição
                                        </label>
                                        <Field
                                            autoFocus
                                            name="dsProduto"
                                            value={values.dsProduto}
                                            disabled={
                                                disableEdit || isSubmitting
                                            }
                                            style={inputComponentStyle(
                                                errors.dsProduto &&
                                                    touched.dsProduto,
                                                disableEdit
                                            )}
                                        />
                                        <ErrorMessage
                                            name="dsProduto"
                                            component="div"
                                            style={styles.errorMessage}
                                        />
                                    </View>

                                    <View style={styles.twoColumns}>
                                        <View
                                            style={[
                                                styles.inputContainer,
                                                styles.firstSon
                                            ]}
                                        >
                                            <label style={styles.label}>
                                                Código de Barras
                                            </label>
                                            <Field
                                                name="nrEan"
                                                type="number"
                                                disabled={
                                                    disableEdit || isSubmitting
                                                }
                                                style={inputComponentStyle(
                                                    errors.nrEan &&
                                                        touched.nrEan,
                                                    disableEdit
                                                )}
                                            />
                                            <ErrorMessage
                                                name="nrEan"
                                                component="div"
                                                style={styles.errorMessage}
                                            />
                                        </View>

                                        <View
                                            style={[
                                                styles.inputContainer,
                                                styles.lastSon
                                            ]}
                                        >
                                            <label style={styles.label}>
                                                Departamento
                                            </label>
                                            <Field
                                                name="idDepartamento"
                                                component="select"
                                                placeholder="Selecione um departamento"
                                                disabled={isSubmitting}
                                                style={selectComponentStyle(
                                                    errors.idDepartamento &&
                                                        touched.idDepartamento,
                                                    false
                                                )}
                                            >
                                                <option
                                                    value=""
                                                    label="Selecione um departamento"
                                                />

                                                {departamentos.length > 0 &&
                                                    departamentos.map((d) => {
                                                        return (
                                                            <option
                                                                value={
                                                                    d.idDepartamento
                                                                }
                                                                key={
                                                                    d.idDepartamento
                                                                }
                                                                label={
                                                                    d.dsDepartamento
                                                                }
                                                            />
                                                        );
                                                    })}
                                            </Field>
                                            <ErrorMessage
                                                name="idDepartamento"
                                                component="div"
                                                style={styles.errorMessage}
                                            />
                                        </View>
                                    </View>

                                    <View style={styles.twoColumns}>
                                        <View
                                            style={[
                                                styles.inputContainer,
                                                styles.firstSon
                                            ]}
                                        >
                                            <label style={styles.label}>
                                                Preço
                                            </label>
                                            <MaskedInput
                                                mask={moneyMask}
                                                name="vlPreco"
                                                placeholder="R$ 0,00"
                                                type="text"
                                                disabled={
                                                    disableEdit || isSubmitting
                                                }
                                                style={inputComponentStyle(
                                                    errors.vlPreco &&
                                                        touched.vlPreco,
                                                    disableEdit
                                                )}
                                                value={values.vlPreco}
                                                onChange={(e) => {
                                                    const { target } = e,
                                                        { value } = target;

                                                    if (value.length > 12) {
                                                        return;
                                                    }

                                                    handleChange(e);
                                                    setFieldTouched('vlPreco');
                                                }}
                                                onBlur={this.handleBlur}
                                                render={(ref, props) => (
                                                    <Field
                                                        innerRef={ref}
                                                        {...props}
                                                    />
                                                )}
                                            />
                                            <ErrorMessage
                                                name="vlPreco"
                                                component="div"
                                                style={styles.errorMessage}
                                            />
                                        </View>
                                        <View
                                            style={[
                                                styles.inputContainer,
                                                styles.lastSon
                                            ]}
                                        >
                                            <label style={styles.label}>
                                                Preço de Promoção
                                            </label>

                                            <MaskedInput
                                                mask={moneyMask}
                                                name="vlPrecoPromocao"
                                                placeholder="R$ 0,00"
                                                type="text"
                                                disabled={
                                                    disableEdit || isSubmitting
                                                }
                                                style={inputComponentStyle(
                                                    errors.vlPrecoPromocao &&
                                                        touched.vlPrecoPromocao,
                                                    disableEdit
                                                )}
                                                value={values.vlPrecoPromocao}
                                                onChange={(e) => {
                                                    const { target } = e,
                                                        { value } = target;

                                                    if (value.length > 12) {
                                                        return;
                                                    }

                                                    handleChange(e);
                                                    setFieldTouched(
                                                        'vlPrecoPromocao'
                                                    );
                                                }}
                                                onBlur={this.handleBlur}
                                                render={(ref, props) => (
                                                    <Field
                                                        innerRef={ref}
                                                        {...props}
                                                    />
                                                )}
                                            />

                                            <ErrorMessage
                                                name="vlPrecoPromocao"
                                                component="div"
                                                style={styles.errorMessage}
                                            />
                                        </View>
                                    </View>
                                    <View style={styles.twoColumns}>
                                        <View
                                            style={[
                                                styles.inputContainer,
                                                styles.firstSon
                                            ]}
                                        >
                                            <label style={styles.label}>
                                                Início Promoção
                                            </label>
                                            <MaskedInput
                                                mask={dateMask}
                                                name="dtInicioPromocao"
                                                placeholder="DD/MM/AAAA"
                                                type="text"
                                                disabled={
                                                    disableEdit ||
                                                    this.checkHasVlPrecoPromocao() ||
                                                    isSubmitting
                                                }
                                                style={inputComponentStyle(
                                                    errors.dtInicioPromocao &&
                                                        touched.dtInicioPromocao,
                                                    disableEdit ||
                                                        this.checkHasVlPrecoPromocao()
                                                )}
                                                value={values.dtInicioPromocao}
                                                onChange={handleChange}
                                                render={(ref, props) => (
                                                    <Field
                                                        innerRef={ref}
                                                        {...props}
                                                    />
                                                )}
                                            />
                                            <ErrorMessage
                                                name="dtInicioPromocao"
                                                component="div"
                                                style={styles.errorMessage}
                                            />
                                        </View>
                                        <View
                                            style={[
                                                styles.inputContainer,
                                                styles.lastSon
                                            ]}
                                        >
                                            <label style={styles.label}>
                                                Fim Promoção
                                            </label>
                                            <MaskedInput
                                                mask={dateMask}
                                                name="dtFimPromocao"
                                                placeholder="DD/MM/AAAA"
                                                type="text"
                                                disabled={
                                                    disableEdit ||
                                                    this.checkHasVlPrecoPromocao() ||
                                                    isSubmitting
                                                }
                                                style={inputComponentStyle(
                                                    errors.dtFimPromocao &&
                                                        touched.dtFimPromocao,
                                                    disableEdit ||
                                                        this.checkHasVlPrecoPromocao()
                                                )}
                                                value={values.dtFimPromocao}
                                                onChange={handleChange}
                                                render={(ref, props) => (
                                                    <Field
                                                        innerRef={ref}
                                                        {...props}
                                                    />
                                                )}
                                            />
                                            <ErrorMessage
                                                name="dtFimPromocao"
                                                component="div"
                                                style={styles.errorMessage}
                                            />
                                        </View>
                                    </View>
                                </View>
                                <ProdutoProvider
                                    initialState={{
                                        idProduto: produto.idProduto,
                                        images: [...arrImages]
                                    }}
                                >
                                    <FotosComponent
                                        addToast={this.props.addToast}
                                    />
                                </ProdutoProvider>
                            </div>
                        </Form>
                    </div>
                </Modal>
            </Fragment>
        );
    }

    onLoadImage = (e) => {
        const { setFieldValue } = this.props;

        if (
            e.currentTarget &&
            e.currentTarget.files.length > 0 &&
            this.validateImage(e.currentTarget.files[0])
        ) {
            setFieldValue('image', e.currentTarget.files[0]);
        }

        document.getElementById('imageUpload').value = '';
    };

    validateImage = (file) => {
        var type = file.type.split('/').pop().toLowerCase();

        if (
            type !== 'jpeg' &&
            type !== 'jpg' &&
            type !== 'png' &&
            type !== 'gif'
        ) {
            this.toastCaller(
                'O tipo da imagem deve ser jpeg, jpg, png ou gif.',
                'error',
                4500
            );
            return false;
        }
        if (file.size > 1024000) {
            this.toastCaller(
                'O tamanho da imagem deve possuir no máximo 1 MB.',
                'error',
                4500
            );
            return false;
        }

        return true;
    };

    toastCaller = (message, theme, autoHideTime) => {
        this.props.addToast({
            text: message,
            theme: theme,
            autoHideTime: autoHideTime
        });
    };

    removeImage = () => {
        const { setFieldValue } = this.props;

        setFieldValue('image', noImage);
    };

    validateForm = () => {
        this.setState({ ...this.state, isLoading: true });
        const { errors, setFieldTouched, handleSubmit } = this.props,
            arrayOfErrors = Object.keys(errors);

        // Verifica se há algum item no objeto de erros e transforma em um item do arrayOfErrors, que será passado para o objeto touched como true;

        if (!!arrayOfErrors.length > 0) {
            arrayOfErrors.filter((error) => setFieldTouched(error, true));

            this.setState({ ...this.state, isLoading: false });
        } else {
            handleSubmit();
        }
    };
}

const handleFormSubmission = async (values, formikBag) => {
    const { props, setSubmitting } = formikBag;

    const formData = new FormData();
    const {
        idProduto = null,
        dsProduto,
        nrEan,
        idDepartamento,
        dtInicioPromocao,
        dtFimPromocao,
        vlPrecoPromocao = 0,
        image = null
    } = values;

    const clearValue = (v) => {
        if (!v) return;

        try {
            const clearValue = v.replace(/[^\d,]/g, '').replace(',', '.');

            return clearValue;
        } catch (error) {
            return v;
        }
    };

    formData.set('dsProduto', dsProduto);
    formData.set('nrEan', nrEan);
    formData.set('idDepartamento', idDepartamento);
    formData.set('keyWords', null);

    if (values.vlPreco) {
        const vlPreco = clearValue(values.vlPreco);
        formData.set('vlPreco', vlPreco);
    }

    if (idProduto) {
        formData.set('idProduto', idProduto);
    }

    if (image && image.name) {
        formData.append('image', image);
    } else if (image && !image.name) {
        formData.append('image', 'delete');
    }

    const vlPrecoPromocaoAux = vlPrecoPromocao
            ? vlPrecoPromocao.toString().replace(/[^\d]/g, '')
            : '0',
        hasValuePromocao = Number(vlPrecoPromocaoAux) || 0;

    if (hasValuePromocao) {
        const newDtInicio = Moment(dtInicioPromocao, brDtFormat).format(
                usDtFormat
            ),
            newDtFim = Moment(dtFimPromocao, brDtFormat).format(usDtFormat);

        const vlPrecoPromocao = clearValue(values.vlPrecoPromocao);
        formData.set('vlPrecoPromocao', vlPrecoPromocao);
        formData.set('dtInicioPromocao', newDtInicio);
        formData.set('dtFimPromocao', newDtFim);
    }

    saveProduto(formData)
        .then((response) => {
            const { message } = response,
                { produto } = props,
                { idDepartamento } = produto;

            props.addToast({
                text: message,
                theme: 'success',
                autoHideTime: 3000
            });

            props.clearProdutoSelecionado();

            if (idDepartamento) {
                const { query } = props.departamentoSelecionado;

                let params = {};

                if (query) params = { search: query };

                props.searchProdutos({ idDepartamento, params });
            }

            props.onClose();

            props.loadDepartamentoList(true);
        })
        .catch((error) => {
            const { message } = error[0] || {};

            props.addToast({
                text: message,
                theme: 'error',
                autoHideTime: 3000
            });

            setSubmitting(false);
        });
};

const formikEnhancer = withFormik({
    mapPropsToValues: (props) => ({
        dsProduto: '',
        nrEan: '',
        idDepartamento: '',
        vlPreco: 0,
        vlPrecoPromocao: 0,
        dtInicioPromocao: '',
        dtFimPromocao: '',
        image: null
    }),

    validationSchema: produtoSchema,

    handleSubmit: (values, formikBag) => {
        return handleFormSubmission(values, formikBag);
    }
})(ProdutoWrapper);

const mapStateToProps = ({ departamentoSelecionado, produtos, user }) => ({
    departamentoSelecionado,
    produtos,
    user
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...toastActions,
            ...produtosActions,
            ...produtoSelecionadoActions,
            ...departamentoSelecionadoActions
        },
        dispatch
    );

const produtoWrapper = connect(
    mapStateToProps,
    mapDispatchToProps
)(formikEnhancer);

export default produtoWrapper;
